import { render, staticRenderFns } from "./RoundStakingIcon.vue?vue&type=template&id=5593866a&scoped=true&"
import script from "./RoundStakingIcon.vue?vue&type=script&lang=ts&"
export * from "./RoundStakingIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RoundStakingIcon.vue?vue&type=style&index=0&id=5593866a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5593866a",
  null
  
)

export default component.exports